/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import React, { useEffect } from 'react';

export const WistaVideo = ({ video }) => {
  useEffect(() => {
    const script1 = document.createElement('script');
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    script2.async = true;
    document.body.appendChild(script2);
    script1.src = video.script;
    script1.async = true;
    document.body.appendChild(script1);
  }, []);

  return (
    <div className={`wistia_embed ${video.id} videoFoam=true`} />
  );
};
